import React from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { isAuthenticated } from 'helpers/authToken';
import { setLocalSignInRedirect } from 'actions/app';
import { getLocalizedPath } from 'helpers/getLocale';

const DialogActionsWrapper = styled(DialogActions)(({ theme, center }) => ({
  padding: 30,
  paddingTop: 20,
  justifyContent: center ? 'center' : 'flex-end',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'flex-start'
  }
}));

const DialogContentWrapper = styled(DialogContent)(({ center }) => ({
  padding: 30,
  paddingBottom: 0,
  textAlign: center ? 'center' : 'left'
}));

const DialogTitleWrapper = styled(DialogTitle)(({ center }) => ({
  padding: 30,
  paddingBottom: 0,
  marginBottom: 20,
  textAlign: center ? 'center' : 'left'
}));

const NeedAuthDialog = ({ handleClose, needAuth, backDrop = true }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const t = useTranslate('Reviews');

  const handleLoginRedirect = (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (!isAuthenticated()) {
      dispatch(setLocalSignInRedirect(location.pathname));
      navigate(getLocalizedPath('/sign-in'));
    }
  };

  return (
    <Dialog open={needAuth} onClose={backDrop ? handleClose : null}>
      <DialogTitleWrapper center="true">{t('NeedAuthTitle')}</DialogTitleWrapper>
      <DialogContentWrapper center="true">
        <Typography>{t('NeedAuthText')}</Typography>
      </DialogContentWrapper>
      <DialogActionsWrapper center="true">
        <Button variant="outlined" color="primary" onClick={handleClose} aria-label={t('Close')}>
          {t('Close')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleLoginRedirect}
          aria-label={t('SignIn')}>
          {t('SignIn')}
        </Button>
      </DialogActionsWrapper>
    </Dialog>
  );
};

export default NeedAuthDialog;
